var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1655 2.65377C23.8883 1.60811 23.0723 0.784249 22.0346 0.506989C20.1571 -4.72171e-07 12.6077 0 12.6077 0C12.6077 0 5.05835 -4.72171e-07 3.1809 0.506989C2.14316 0.784249 1.32722 1.60811 1.04996 2.65377C0.542969 4.54706 0.542969 8.5 0.542969 8.5C0.542969 8.5 0.542969 12.4529 1.04996 14.3462C1.32722 15.3919 2.14316 16.2158 3.1809 16.493C5.06627 17 12.6077 17 12.6077 17C12.6077 17 20.1571 17 22.0346 16.493C23.0723 16.2158 23.8883 15.3919 24.1655 14.3462C24.6725 12.4529 24.6725 8.5 24.6725 8.5C24.6725 8.5 24.6725 4.54706 24.1655 2.65377Z",
    fill: "#3AA3B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.144 12.0887V4.91162L16.4497 8.50016L10.144 12.0887Z",
    fill: "#1E1A78"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.dfd0c639be17b88fc17cf0e6f18df3c6.svg";
export { ForwardRef as ReactComponent };